<template>
  <div class="laid-out-check-boxes vuetify-fz fz-32">
    <template v-for="(option, key) in options">
      <v-chip
        :key="key"
        label
        :outline="!isSelected(key)"
        :dark="isSelected(key)"
        :color="isSelected(key) ? 'primary' : '#616161'"
        @click="submitData(Number(key))"
      >{{ transI18n(option) }}</v-chip>
      
    </template>
  </div>
</template>

<script>
	export default {
		name: 'LaidOutCheckBoxes',

		props: {
      options: {
        required: true,
        type: Object
      },

      value: {
        required: false,
        type: Array
      },
      transI18n: {
        type: Function,
        required: true
      }
    },
    methods: {
      isSelected (optionValue) {
        return this.value.indexOf(Number(optionValue)) >= 0
      },
      submitData (key) {
        const newValue = this.isSelected(key) ? null : key
        this.$emit('change', newValue)
      }
    }
	}
</script>

<style lang="scss">
@import "@/styles/mixins";

.laid-out-check-boxes {
  display: inline-flex;
  flex-wrap: wrap;
}
</style>